module.exports = __webpack_public_path__ + "media/recipes/121-cadf67bf.png";